<template>
    <div>
        <span
            v-html="$t('notification.reservationCreated',{ name: $_.get(activity,'payload.userName'), visitor: maskedVisitorFullname, date: $_.get(activity, 'payload.date')})"></span>
    </div>
</template>
<script>
import _ from "lodash";
import activityVisitorMaskMixin from "./activityVisitorMaskMixin";

export default {
    name: "ReservationCreated",
    mixins: [activityVisitorMaskMixin],
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        maskedVisitorFullname() {
            return this.maskVisitorDisplayName(_.get(this.activity, "payload.visitorFullname"));
        },
    },
};
</script>
<style></style>
